export var BendType;
(function (BendType) {
    BendType["ARC"] = "arc";
    BendType["NONE"] = "none";
})(BendType || (BendType = {}));
export var PathSlopeType;
(function (PathSlopeType) {
    PathSlopeType["STRAIGHT"] = "straight";
    PathSlopeType["CROSS"] = "cross";
})(PathSlopeType || (PathSlopeType = {}));
//# sourceMappingURL=interface.js.map